@if (sanitizedHtml(); as content) {
    <div
        [class]="class() + ' [&_ul]:ms-[1.25em] [&_ol]:ms-[1.25em] break-words'"
        [innerHTML]="content"></div>
}
